export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/branch-offices/getters.js